module.exports = __webpack_public_path__ + "img/1.c9fc4f20.jpg";